import React from "react";
import { Link } from "react-router-dom";
import { useStyles } from "./styles";

export const NewsWidgetContent = ({ children, to, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.content} ref={ref} title={typeof children === "string" ? children : ""}>
      <Link to={to}>{children}</Link>
    </div>
  );
};
NewsWidgetContent.muiName = "NewsWidgetContent";
NewsWidgetContent.displayName = "NewsWidgetContent";

export default NewsWidgetContent;
